module.exports = __webpack_public_path__ + "static/img/add_miniapp.34a69df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_miniapp.jpg
// module id = FAZp
// module chunks = 31